import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Activities() {
  const [form, setForm] = useState({
    image: null,
  });
  const [selectedImage, setSelectedImage] = useState(null);

  const [activities, setActivities] = useState([]);

  // 🔄 Fetch Activities
  const getActivities = () => {
    fetch(`${BASE_URL}/api/getActivities.php`)
      .then((res) => res.json())
      .then((data) => setActivities(data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getActivities();
  }, []);

  // Handle File
  const handleChange = (e) => {
    setForm({ image: e.target.files[0] });
  };

  // Submit Form
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", form.image);

    fetch(`${BASE_URL}/api/addActivity.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        getActivities();
        setForm({ image: null });
        document.querySelector('input[type="file"]').value = "";
      });
  };

  // Delete Activity
  const deleteActivity = (id) => {
    if (!window.confirm("Are you sure you want to delete this activity?"))
      return;

    fetch(`${BASE_URL}/api/deleteActivities.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        alert(data.message);
        getActivities();
      });
  };

  return (
    <div className="activity-page">
      {/* FORM */}
      <div className="form-container">
        <h2>➕ પ્રવૃત્તિ ઉમેરો</h2>

        <form onSubmit={handleSubmit} className="form">
          <input type="file" name="image" onChange={handleChange} required />

          <button type="submit">Submit</button>
        </form>
      </div>

      {/* TABLE */}
      {/* IMAGE CARDS */}
      <div className="activity-gallery">
        <h2>પ્રવૃત્તિ યાદી</h2>

        <div className="activity-grid">
          {activities.length > 0 ? (
            activities.map((item) => (
              <div className="activity-card" key={item.id}>
                {/* Delete Button */}
                <button
                  className="delete-icon"
                  onClick={() => deleteActivity(item.id)}
                >
                  ×
                </button>

                {/* Image */}
                <img
                  src={`${BASE_URL}/uploads/${item.image}`}
                  alt=""
                  onClick={() =>
                    setSelectedImage(`${BASE_URL}/uploads/${item.image}`)
                  }
                />

                {/* Date */}
                <div className="activity-date">
                  <i className="fa fa-calendar"></i> {item.date}
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">કોઈ પ્રવૃત્તિ નથી</div>
          )}
        </div>
      </div>
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>

            <img src={selectedImage} alt="Preview" />
          </div>
        </div>
      )}
    </div>
  );
}
